import { useEffect } from 'react';
import { PUBLICATION_UNAVAILABLE_EVENT_NAME } from '../../Microfrontend/services/microfrontEventSender/constants';

export const usePublicationUnavailableListener = (callback: (e: CustomEvent) => void) => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    window.addEventListener(PUBLICATION_UNAVAILABLE_EVENT_NAME, callback);

    return () => {
      window.removeEventListener(PUBLICATION_UNAVAILABLE_EVENT_NAME, callback);
    };
  }, [callback]);
};
